var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21753 0 0 .20858 15.452 11.945)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.88934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.1s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.17599 .1226 -.12786 .16874 12.668 15.246)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.83934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.2s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.06722 .19837 -.20688 .06445 7.983 15.62)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.78934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.3s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.06722 .19837 -.20688 -.06445 4.874 13.215)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.73934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.4s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.17599 .1226 -.12786 -.16874 4.202 9.658)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.68934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.5s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.21753 0 0 -.20858 6.122 6.494)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.63934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.6s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.06722 -.19837 .20688 .06445 10.515 4.651)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.98934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.7s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.17599 -.1226 .12786 .16874 14.746 7.338)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 8,
    transform: "scale(.93934)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.8s",
    dur: "0.8s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "scale",
    values: "1 1;0.1 0.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLoader);
export default __webpack_public_path__ + "6790a1daaed987b90428003e72e3967e.svg";
export { ForwardRef as ReactComponent };